module.exports = __webpack_public_path__ + "img/course.d47cac97.png";